import { ApiRetailerPaymentType } from '@vend/types'
import { vn } from 'vend-number'
import uuid from '@vend/vend-uuid'
import { useAppSelector } from '../../../../state/hooks'
import { selectCurrentSale } from '../../../../state/slices/currentSale/currentSaleSlice'
import { EcomRefundOption } from '../PaymentModal/types'
import { isReturnedEcomPayPalSale } from '../../../../functions/payment-types/paypalEcom'

export const useHandleEcomRefundPayment = (amountTendered: string) => {
  const sale = useAppSelector(selectCurrentSale)

  const handleEcomRefundPayment = (
    paymentType: ApiRetailerPaymentType
  ): EcomRefundOption | undefined => {
    if (!sale.returnFor) {
      return
    }

    let paymentModalType: 'lsPayEcomRefund' | 'paypalEcomRefund' =
      'lsPayEcomRefund'
    if (isReturnedEcomPayPalSale(sale)) {
      paymentModalType = 'paypalEcomRefund'
    }

    return {
      originalSaleId: sale.returnFor,
      paymentModalType,
      amount: vn(amountTendered).toNumber(),
      paymentType,
      registerId: sale.registerId || '',
      registerSalePaymentId: uuid(),
    }
  }

  return {
    handleEcomRefundPayment,
  }
}
